/**
 * requestIdleCallback is not supported in all browsers, so we need to use setTimeout as a fallback.
 * @param callback - The callback to execute when the browser is idle.
 * @returns The id of the idle callback.
 */

export function wilsonRequestIdleCallback(
  callback: () => void,
  delay = 10,
): ReturnType<typeof setTimeout> | ReturnType<typeof requestIdleCallback> {
  if ('requestIdleCallback' in window) {
    return requestIdleCallback(callback);
  } else {
    return setTimeout(callback, delay);
  }
}

/**
 * cancelIdleCallback is not supported in all browsers, so we need to use clearTimeout as a fallback.
 * @param id - The id of the idle callback to cancel.
 */
export function wilsonCancelIdleCallback(
  id: ReturnType<typeof wilsonRequestIdleCallback>,
): void {
  if ('cancelIdleCallback' in window) {
    cancelIdleCallback(id as number);
  } else {
    clearTimeout(id);
  }
}
